var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel panel-default" },
    [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              _vm.collapsed = !_vm.collapsed
            },
          },
        },
        [
          _vm._v("\n\t\tOuvrir "),
          _c("collapse-indicator", { attrs: { open: !_vm.collapsed } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.collapsed,
                expression: "!collapsed",
              },
            ],
          },
          [
            _c("table", { staticClass: "table" }, [
              _vm.order.Subtotal != _vm.order.Total
                ? _c("tr", [
                    _c("td", [_vm._v("Sous-total")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Subtotal))),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              +_vm.order.ShippingFee
                ? _c("tr", [
                    _c("td", [_vm._v("Frais de livraison")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.ShopService.prix(_vm.order.ShippingFee)) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              +_vm.order.ProcessingFee
                ? _c("tr", [
                    _c("td", [_vm._v("Frais de gestion")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(
                        _vm._s(_vm.ShopService.prix(_vm.order.ProcessingFee))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              +_vm.order.Tip
                ? _c("tr", [
                    _c("td", [_vm._v("Pourboire")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Tip))),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              +_vm.order.Discount
                ? _c("tr", [
                    _c("td", [
                      !_vm.order.promo_code
                        ? _c("div", [_vm._v("Remise")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm.order.promo_code
                          ? _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.order.DiscountName) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.ShopService.prix(_vm.order.Discount)) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Total")]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "right" } }, [
                  _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Total))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("order-summary-mini", { attrs: { order: _vm.order } }),
            _vm._v(" "),
            _vm.order.Total != _vm.remain
              ? _c("table", { staticClass: "table" }, [
                  _c("tr", [
                    _c("td", [_vm._v("Déjà réglé")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "white-space": "nowrap",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.ShopService.prix(
                                -(_vm.order.Total - _vm.remain)
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "warning" }, [
                    _c("td", [_vm._v("Reste à payer")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(_vm._s(_vm.ShopService.prix(_vm.remain))),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.collapsed
        ? _c("div", [
            _c("table", { staticClass: "table" }, [
              +_vm.order.ShippingFee
                ? _c("tr", [
                    _c("td", [_vm._v("Frais de livraison")]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.ShopService.prix(_vm.order.ShippingFee)) +
                          "\n\t\t\t\t"
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }